import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateString'
})
export class TruncateStringPipe implements PipeTransform {

  transform(value: string, maxLength: number): unknown {
    if (value?.length > maxLength) {
      value = `${value.substring(0, maxLength)} ...`;
    }
    return value;
  }

}
